/* Self-contained components also initialize on Shopify editor section reloads. */
if (!customElements.get('pell-slideshow')) {
  customElements.define('pell-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) { this.start(); return; }
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
      this.paused = this.getAttribute('data-autoplay') !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.start(); });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.start(); });
      this.start();
      this.onSelect = (event) => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.start(); this.show(index); }
      };
      this.addEventListener('shopify:block:select', this.onSelect);
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      if (this.pauseButton) { this.pauseButton.textContent = this.paused ? 'Play' : 'Pause'; this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow'); }
      if (!this.paused && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), (Number(this.getAttribute('data-interval')) || 6) * 1000);
    }
    disconnectedCallback() { this.stop(); }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
    }
  });
}
if (!customElements.get('pell-collection-tabs')) {
  customElements.define('pell-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.show(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.show(next); this.tabs[next].focus(); }
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.show(index);
      });
    }
    show(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
  });
}

(() => {
  const updateHeader = () => {
    document.documentElement.classList.toggle('pell-home-scrolled', window.scrollY > 40);
  };
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('pageshow', updateHeader);
  document.addEventListener('shopify:section:load', updateHeader);
  updateHeader();
})();
